import React from "react";
import { useAppSelector } from "../../../../store/index.ts";
import ShowContainer from "../../../mui/ShowContainer.jsx";
import BannerItem from "../../../landing/banners/banner_item/BannerItem.jsx";
import "./dynamic-banners.scss";
import CustomCarousel from "../../../mui/custom-carousel/CustomCarousel.jsx";
import useBanners from "../../../../hooks/other/useBanners";

export default function DynamicBanners() {
  const banners = useBanners();
  const bannerPosition = useAppSelector((state) => state.site.bannerPosition);

  return (
    <ShowContainer condition={banners.length}>
      <section className="dynamic-banners">
        {banners.length > 1 ? (
          <CustomCarousel
            className="dynamic-banners__carousel"
            loop={true}
            speed={500}
            spaceBetween={8}
            slidesPerView={1}
            autoplay={{
              delay: 8000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }}
            initialSlide={bannerPosition}
            pagination={{ clickable: true }}
            navigation={false}>
            {banners.map((el, indx) => (
              <BannerItem key={el.id} {...el} position={indx} />
            ))}
          </CustomCarousel>
        ) : (
          <div className="dynamic-banners__carousel ">
            <BannerItem {...banners[0]} />
          </div>
        )}
      </section>
    </ShowContainer>
  );
}
